import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const responseSchema = z.object({
  sp_api_fawcett_credential_disabled: z.boolean(),
  sp_api_authorized: z.boolean(),
  seller_id_mismatch_detected: z.boolean(),
});

export const spApiCredentialCheckDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "checkSpApiCredential",
    method: "get",
    path: "/sp_api_credential_check",
    parameters: [
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: responseSchema,
  }).build(),
);
